import { render, staticRenderFns } from "./BaseSetting.vue?vue&type=template&id=9e2c15da&scoped=true"
import script from "./BaseSetting.vue?vue&type=script&lang=js"
export * from "./BaseSetting.vue?vue&type=script&lang=js"
import style0 from "./BaseSetting.vue?vue&type=style&index=0&id=9e2c15da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2c15da",
  null
  
)

export default component.exports